




































































































































import { Component, Vue } from "vue-property-decorator";
import { Lazyload, ImagePreview, Overlay, ActionSheet } from "vant";
import bannerTop from "./components/bannerTop.vue"
import navTop from "./components/navTop.vue"
import downloadModel from "./model/downloadModel.vue";
Vue.use(Lazyload).use(ImagePreview).use(Overlay).use(ActionSheet);
@Component({
  components: { bannerTop, navTop, downloadModel },
})
export default class Home extends Vue {
  public mobile: any = "";
  public mobileSystem = "";
  public titleOneShow = true;
  public titleTwoShow = false;
  public titleThreeShow = false;
  public show = false;
  public tagVersionId: any = -1;
  public tagVersionIds: any = -1;
  public menuState = false;
  public len: any = 0;
  public lens: any = 5;
  public loading = false;
  public dataList: any = [];
  public tagVersionList: any = [];
  public tagVersionLists: any = [];
  public adList: any = [];
  public iosList: any = [];
  public mbList: any = [];
  public allList: any = [];
  public loadingShow = false;
  public type = 0;
  public menuActive = false;
  // public baseUrl = "http://tg-test.996box.com"; // 测试
  public baseUrl = "http://tgdata.996box.com"; // 正式
  public iosBox = "";
  public adBox = "";
  public vanShow = false;
  public top: any = 0;
  public gameLink: any = {}
  public baseUrls = "http://tgdata.996box.com"
  public created() {
    this.$fn.userRecord("2200", 1, "");
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  public mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.mobile =
      navigator.appVersion.indexOf("iPhone") !== -1 ? "iPhone" : "android";
    this.lens = 5;
    this.dataList = [];
    const type = 3;
    const that = this;
    window.addEventListener("scroll", this.add);
    // 判断移动pc
    // console.log(this.isMobile())
    // alert(navigator.userAgent)
    this.getGameLink()
    if (this.isMobile()) {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // 判断ios az
      if (isiOS) {
        this.mobileSystem = "ios";
      } else {
        this.mobileSystem = "ad";
      }
      this.getList();
    } else {
      location.href = "http://www.996box.com";
    }
  }
  public async getGameLink() {
    this.$axios.get(this.baseUrls + "/down_url.json").then((res) => {
      this.gameLink = res.data
    });
  }
  public isMobile() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  }
  public itImgClick(item) {
    item.show = false;
  }
  // 获取ios ad数据
  public async getList() {
    const iosUrl = "/tglist_ios.json";
    const adUrl = "/tglist_ad.json";
    let url = "";
    this.mobileSystem == "ios" ? (url = iosUrl) : (url = adUrl);
    this.$axios.get(this.baseUrl + url).then((resp) => {
      if (resp.data != "") {
        this.iosBox = resp.data.down_url_ios;
        this.adBox = resp.data.down_url_ad;
        const data = resp.data;
        const arr: any = [];
        const dataLists: any = []; // 最后需要的数据
        data.list.forEach((item) => {
          if (!arr.includes(item.open_time)) {
            arr.push(item.open_time);
            dataLists.push({ list: [] });
          }
        });
        data.list.forEach((item) => {
          const indexs = arr.indexOf(item.open_time);
          dataLists[indexs].list.push(item);
        });
        dataLists.forEach((item) => {
          item.list.forEach((items) => {
            this.$set(items, "show", false);
            items.publicity.forEach((itemss) => {
              this.$set(itemss, "show", true);
            });
          });
        });
        data.versions.forEach((item) => {
          this.$set(item, "show", false);
        });
        data.tags.forEach((item) => {
          this.$set(item, "show", false);
        });
        const arrays = dataLists.slice(this.len, this.lens);
        if (this.lens > dataLists.length) {
          this.loadingShow = true;
        }
        this.loading = false;
        if (this.mobileSystem == "ios") {
          this.iosList = dataLists;
          this.dataList = arrays;
          this.tagVersionList = data.versions;
          this.tagVersionLists = data.tags;
        }
        if (this.mobileSystem == "ad") {
          this.adList = dataLists;
          this.dataList = arrays;
          this.tagVersionList = data.versions;
          this.tagVersionLists = data.tags;
        }
      }
    });
  }
  // 获取手机端 三端数据
  public async getAllList(type) {
    let url = "";
    type == 1 ? (url = "/tglist_mobile.json") : (url = "/tglist_all.json");
    this.$axios.get(this.baseUrl + url).then((resp) => {
      if (resp.data.list != undefined) {
        const data = resp.data;
        const arr: any = [];
        const dataLists: any = []; // 最后需要的数据
        data.list.forEach((item) => {
          if (!arr.includes(item.open_time)) {
            arr.push(item.open_time);
            dataLists.push({ list: [] });
          }
        });
        data.list.forEach((item) => {
          const indexs = arr.indexOf(item.open_time);
          dataLists[indexs].list.push(item);
        });
        dataLists.forEach((item) => {
          item.list.forEach((items) => {
            this.$set(items, "show", false);
          });
        });
        const arrays = dataLists.slice(this.len, this.lens);
        if (this.lens > dataLists.length) {
          this.loadingShow = true;
        }
        this.loading = false;
        if (type == 1) {
          this.mbList = dataLists;
        }
        if (type == 2) {
          this.allList = dataLists;
        }
        this.dataList = arrays;
        data.versions.forEach((item) => {
          this.$set(item, "show", false);
        });
        data.tags.forEach((item) => {
          this.$set(item, "show", false);
        });
      } else {
        this.dataList = [];
      }
    });
  }
  // 获取手机端 三端数据
  public async getAllLists(type) {
    const dataLists = [];
    if (type == 11) {
      if (this.lens >= this.iosList.length) {
        this.lens = this.iosList.length;
        this.dataList = this.iosList.slice(this.len, this.lens);
        this.loading = false;
        this.loadingShow = true;
        return false;
      }
      this.dataList = this.iosList.slice(this.len, this.lens);
      this.loading = false;
      return false;
    }
    if (type == 12) {
      if (this.lens >= this.adList.length) {
        this.lens = this.adList.length;
        this.dataList = this.adList.slice(this.len, this.lens);
        this.loading = false;
        this.loadingShow = true;
        return false;
      }
      this.dataList = this.adList.slice(this.len, this.lens);
      this.loading = false;
      return false;
    }
    if (type == 1) {
      if (this.lens >= this.mbList.length) {
        this.lens = this.mbList.length;
        this.dataList = this.mbList.slice(this.len, this.lens);
        this.loading = false;
        this.loadingShow = true;
        return false;
      }
      this.dataList = this.mbList.slice(this.len, this.lens);
      this.loading = false;
      return false;
    }
    if (type == 2) {
      if (this.lens >= this.allList.length) {
        this.lens = this.allList.length;
        this.dataList = this.allList.slice(this.len, this.lens);
        this.loading = false;
        this.loadingShow = true;
        return false;
      }
      this.dataList = this.allList.slice(this.len, this.lens);
      this.loading = false;
    }
  }
  // 初始页面的时候展示数据
  public add() {
    const a = document.documentElement.scrollTop;
    const b = document.documentElement.clientHeight;
    const c = document.documentElement.scrollHeight;
    if (c - a - b < 1) {
      this.information_Load();
    }
  }
  // 上拉加载
  public information_Load() {
    if (this.menuActive) {
      if (this.titleOneShow == true) {
        if (this.loadingShow) {
          return false;
        }
        this.loading = true;
        if (this.mobileSystem == "ios") {
          if (this.lens < this.iosList.length) {
            this.lens = this.lens + 5;
            setTimeout(() => {
              this.getAllLists(11);
            }, 400);
            return false;
          }
        }
        if (this.mobileSystem == "ad") {
          if (this.lens < this.adList.length) {
            this.lens = this.lens + 5;
            setTimeout(() => {
              this.getAllLists(12);
            }, 400);
            return false;
          }
        }
      }
      if (this.titleTwoShow == true) {
        if (this.loadingShow) {
          return false;
        }
        this.loading = true;
        if (this.lens < this.mbList.length) {
          this.lens = this.lens + 5;
        }
        setTimeout(() => {
          this.getAllLists(1);
        }, 400);
        return false;
      }
      if (this.titleThreeShow == true) {
        if (this.loadingShow) {
          return false;
        }
        this.loading = true;
        if (this.lens < this.allList.length) {
          this.lens = this.lens + 5;
        }
        setTimeout(() => {
          this.getAllLists(2);
        }, 400);
        return false;
      }
    } else {
      if (this.titleOneShow == true) {
        if (this.loadingShow) {
          return false;
        }
        this.loading = true;
        if (this.mobileSystem == "ios") {
          if (this.lens < this.iosList.length) {
            this.lens = this.lens + 5;
          }
        }
        if (this.mobileSystem == "ad") {
          if (this.lens < this.adList.length) {
            this.lens = this.lens + 5;
          }
        }
        setTimeout(() => {
          this.getList();
        }, 400);
        return false;
      }
      if (this.titleTwoShow == true) {
        if (this.loadingShow) {
          return false;
        }
        this.loading = true;
        if (this.lens < this.mbList.length) {
          this.lens = this.lens + 5;
        }
        setTimeout(() => {
          this.getAllList(1);
        }, 400);
        return false;
      }
      if (this.titleThreeShow == true) {
        if (this.loadingShow) {
          return false;
        }
        this.loading = true;
        if (this.lens < this.allList.length) {
          this.lens = this.lens + 5;
        }
        setTimeout(() => {
          this.getAllList(2);
        }, 400);
        return false;
      }
    }
  }
  // nav点击
  public addNav(ev) {
    if (ev == 4) {
      this.menuState = true
      return false
    }
    this.loadingShow = false;
    this.menuActive = false;
    this.lens = 5;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.tagVersionList.forEach((item) => {
      item.show = false;
    });
    this.tagVersionLists.forEach((item) => {
      item.show = false;
    });
    if (ev == 1) {
      this.getList();
      this.titleOneShow = true;
      this.titleTwoShow = false;
      this.titleThreeShow = false;
    }
    if (ev == 2) {
      this.getAllList(1);
      this.titleOneShow = false;
      this.titleTwoShow = true;
      this.titleThreeShow = false;
    }
    if (ev == 3) {
      this.getAllList(2);
      this.titleOneShow = false;
      this.titleTwoShow = false;
      this.titleThreeShow = true;
    }
  }
  public addClickShow(index, indexs, event) {
    this.$fn.userRecord("2202", 1, "");
    //   var DOM = event.currentTarget;
    // 获取节点距离浏览器视口的高度
    // var top = event.currentTarget.getBoundingClientRect().top;
    // 获取节点距离浏览器视口的宽度
    // var left = event.currentTarget.getBoundingClientRect().left;
    // 获取滚动条滚动距离
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    this.dataList[index].list[indexs].top = scrollTop;
    // 两个top相加就是节点真正的top值
    this.dataList[index].list[indexs].show = true;
  }
  public addToggle(index, indexs) {
    document.body.scrollTop = this.dataList[index].list[indexs].top;
    document.documentElement.scrollTop = this.dataList[index].list[indexs].top;
    this.dataList[index].list[indexs].show = false;
  }
  // 版本选择
  public addtagVersionId(item) {
    this.tagVersionList.forEach((items) => {
      if (item.id != items.id) {
        items.show = false;
      }
    });
    item.show == false ? (item.show = true) : (item.show = false);
    if (item.show == true) {
      this.tagVersionId = item.version_name;
    } else {
      this.tagVersionId = -1;
    }
  }
  // 特色选择
  public addtagVersionIds(item) {
    this.tagVersionLists.forEach((items) => {
      if (item.tag_id != items.tag_id) {
        items.show = false;
      }
    });
    item.show == false ? (item.show = true) : (item.show = false);
    if (item.show == true) {
      this.tagVersionIds = item.tag_name;
    } else {
      this.tagVersionIds = -1;
    }
  }
  // 菜单点击隐藏加防止穿透
  public modalShow(ev) {
    const el1 = ev.currentTarget;
    const el2 = ev.target;
    if (el1 == el2) {
      this.menuState = false;
    }
  }
  // 菜单点击确定
  public menuSave() {
    this.lens = 5;
    this.menuActive = true;
    this.loadingShow = false;
    if (this.tagVersionId == -1 || this.tagVersionId === "") {
      if (this.tagVersionIds == -1 || this.tagVersionIds === "") {
        this.lens = 5;
        if (this.titleOneShow) {
          this.menuActive = false;
          this.getList();
          this.menuState = false;
          return false;
        }
        if (this.titleTwoShow) {
          this.menuActive = false;
          this.getAllList(1);
          this.menuState = false;
          return false;
        }
        if (this.titleThreeShow) {
          this.menuActive = false;
          this.getAllList(2);
          this.menuState = false;
          return false;
        }
        return false;
      }
    }
    const datas: any = [];
    const arr: any = [];
    const dataLists: any = []; // 最后需要的数据
    let url: any = "";
    if (this.mobileSystem == "ios" && this.titleOneShow == true) {
      url = "/tglist_ios.json";
    }
    if (this.mobileSystem == "ad" && this.titleOneShow == true) {
      url = "/tglist_ad.json";
    }
    if (this.titleTwoShow == true) {
      url = "/tglist_mobile.json";
    }
    if (this.titleThreeShow == true) {
      url = "/tglist_all.json";
    }
    this.$axios.get(this.baseUrl + url).then((resp) => {
      const data = resp.data;
      if (this.tagVersionId != -1 && this.tagVersionIds != -1) {
        data.list.forEach((item) => {
          if (
            item.tag_version.indexOf(this.tagVersionId) >= 0 &&
            item.tag_version.indexOf(this.tagVersionIds) >= 0
          ) {
            datas.push(item);
          }
        });
        datas.forEach((item) => {
          if (!arr.includes(item.open_time)) {
            arr.push(item.open_time);
            dataLists.push({ list: [] });
          }
        });
        datas.forEach((item) => {
          const indexs = arr.indexOf(item.open_time);
          dataLists[indexs].list.push(item);
        });
        dataLists.forEach((item) => {
          item.list.forEach((items) => {
            this.$set(items, "show", false);
          });
        });
        if (this.lens >= dataLists.length) {
          this.lens = dataLists.length;
          this.loadingShow = true;
        }
        const arrays = dataLists.slice(this.len, this.lens);
        this.loading = false;
        this.dataList = arrays;
        if (this.mobileSystem == "ios" && this.titleOneShow == true) {
          this.iosList = dataLists;
        }
        if (this.mobileSystem == "ad" && this.titleOneShow == true) {
          this.adList = dataLists;
        }
        if (this.titleTwoShow == true) {
          this.mbList = dataLists;
        }
        if (this.titleThreeShow == true) {
          this.allList = dataLists;
        }
      } else if (this.tagVersionId == -1 && this.tagVersionIds != -1) {
        data.list.forEach((item) => {
          if (item.tag_version.indexOf(this.tagVersionIds) >= 0) {
            datas.push(item);
          }
        });
        datas.forEach((item) => {
          if (!arr.includes(item.open_time)) {
            arr.push(item.open_time);
            dataLists.push({ list: [] });
          }
        });
        datas.forEach((item) => {
          const indexs = arr.indexOf(item.open_time);
          dataLists[indexs].list.push(item);
        });
        dataLists.forEach((item) => {
          item.list.forEach((items) => {
            this.$set(items, "show", false);
          });
        });
        if (this.lens >= dataLists.length) {
          this.lens = dataLists.length;
          this.loadingShow = true;
        }
        const arrays = dataLists.slice(this.len, this.lens);
        this.loading = false;
        this.dataList = arrays;
        if (this.mobileSystem == "ios" && this.titleOneShow == true) {
          this.iosList = dataLists;
        }
        if (this.mobileSystem == "ad" && this.titleOneShow == true) {
          this.adList = dataLists;
        }
        if (this.titleTwoShow == true) {
          this.mbList = dataLists;
        }
        if (this.titleThreeShow == true) {
          this.allList = dataLists;
        }
      } else if (this.tagVersionId != -1 && this.tagVersionIds == -1) {
        data.list.forEach((item) => {
          if (item.tag_version.indexOf(this.tagVersionId) >= 0) {
            datas.push(item);
          }
        });
        datas.forEach((item) => {
          if (!arr.includes(item.open_time)) {
            arr.push(item.open_time);
            dataLists.push({ list: [] });
          }
        });
        datas.forEach((item) => {
          const indexs = arr.indexOf(item.open_time);
          dataLists[indexs].list.push(item);
        });
        dataLists.forEach((item) => {
          item.list.forEach((items) => {
            this.$set(items, "show", false);
          });
        });
        if (this.lens >= dataLists.length) {
          this.lens = dataLists.length;
          this.loadingShow = true;
        }
        const arrays = dataLists.slice(this.len, this.lens);
        this.loading = false;
        this.dataList = arrays;
        if (this.mobileSystem == "ios" && this.titleOneShow == true) {
          this.iosList = dataLists;
        }
        if (this.mobileSystem == "ad" && this.titleOneShow == true) {
          this.adList = dataLists;
        }
        if (this.titleTwoShow == true) {
          this.mbList = dataLists;
        }
        if (this.titleThreeShow == true) {
          this.allList = dataLists;
        }
      }
      this.menuState = false;
    });
  }
  public getListImg(name, list) {
    const data: any = [];
    let idx = 0;
    list.forEach((item) => {
      if (item.type == 1) {
        data.push(item.publicity_url);
      }
    });
    for (let i = 0; i < data.length; i++) {
      if (name == data[i]) {
        idx = i;
      }
    }
    ImagePreview({
      images: data,
      startPosition: idx,
    });
  }
  // 点击弹出下载框
  public addDownload(items) {
    const $downloadModel: any = this.$refs.downloadModel;
    $downloadModel.show(this.gameLink, items, this.mobileSystem);
  }
  // 点击下载盒子
  public getBox() {
    this.$fn.userRecord("2201", 2, "");
    let url = "";
    if (this.mobileSystem == "ios") {
      window.open("https://www.pgyer.com/nMJp/", "_blank");
      // const arr: any = JSON.parse(this.gameLink.enterprise_signs)
      // const sar = Math.floor((Math.random() * arr.length));
      // url = arr[sar]
    } else {
      url = this.gameLink.android_down_url
    }
    const ua: any = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      alert("微信内置浏览器 请打开浏览器下载");
    } else if (ua.match(/QQ/i) == "qq") {
      alert("QQ内置浏览器 请打开浏览器下载");
    } else {
      location.href = url;
      return false;
    }
  }
}
